import Container from "../components/Container";
import { ReactComponent as CornerRose } from "../vectors/CornerRose.svg";
import FlowerDivider from "../components/FlowerDivider";
import FadeIn from "../motions/FadeIn";
import Section from "./Section";

function PageTemplate({
    title,
    minor = false,
    textColor = "text-gold",
    bgColor = "bg-white",
    children
}) {

    return (
        <div className={`${bgColor} min-h-screen flex flex-col text-center text-base sm:text-lg md:text-xl`}>
            {/* Main content with grow */}
            <div className="flex-grow">
                <div className="h-12" />
                <Section className="relative" bgColor>
                    {/* Corner Decorations */}
                    <CornerRose
                        className={`w-1/5 min-w-28 max-w-80 h-auto fill-current absolute left-0 top-0 z-0 ${textColor}`}
                    />
                    <CornerRose
                        className={`w-1/5 min-w-28 max-w-80 h-auto fill-current absolute right-0 top-0 z-0 -scale-x-100 ${textColor}`}
                    />
                    <Container>
                        <div>
                            <FadeIn delay={0.3}>
                                <p className={`${minor ? "small-title" : "title"} ${textColor} `}>{title}</p>
                            </FadeIn>
                            <FadeIn delay={0.6}>
                                <FlowerDivider fillColor={textColor} />
                            </FadeIn>
                        </div>
                    </Container>
                </Section>
                <Section bgColor>
                    <FadeIn delay={0.9}>
                        {children}
                    </FadeIn>
                </Section>
            </div>

            {/* <Footer /> */}
        </div>
    );
}


export default PageTemplate;
